import {useEffect, useRef, useState} from 'react';

export const targetEvent = (fn) => ({
    target: {
        value
    }

}) => fn(value);

export const wraper = (fn, ...args) => () => {
    fn(...args);
};

export const addStyle = (style, styleError, bol) => {
    if (bol) {
        return style + ' ' + styleError;
    }
    return style;
};

export const toParam = (obj) => {
    const keys = Object.keys(obj);

    const str = keys.reduce((acc, item) => {
        return acc + item + '=' + obj[item] + '&';
    }, '?');

    return str;
};

export const requestAuth = (data) => {
    const config = {};
    if (typeof data === 'string') {
        Object.assign(config, {
            headers: {
                Authorization: `Bearer ${data}`
            }
        });
        return config;
    }
    const {
        token,
        ...params
    } = data;
    Object.assign(config, {
        headers: {
            Authorization: `Bearer ${token}`
        },
        params,
    });
    return config;
};

export const concatClasses = (...args) => {
    const style = args.join(' ');

    return style;
};

export const queryParser = (str) => {
    const cutStr = str.slice(1);
    const coupleStr = cutStr.split('&').map(item => item.split('='));
    const obj = coupleStr.reduce((acc, [key, value]) => {
        return {
            ...acc,
            [key.replace('+', '_')]: decodeURIComponent(value),
        };
    }, {});
    return obj;
};


export const callTimeOut = (fn, sec) => {
    const time = sec * 1000;
    setTimeout(fn, time);
};

// Old version for live location part

export const getFireBaseData = (database, table, params, dispatch, reducer, errorHandler) => {
    const userData = database.database().ref(table + params);

    userData.once('value').then(snapshot => {
        if (snapshot.val()) {
            dispatch(reducer(snapshot.val()));
        } else {
            dispatch(errorHandler());
        }
    });
};

//Newer Version
export const getFireBaseInfo = (database, table, params, callback, errorHandler) => {
    const userData = database.database().ref(table + params);

    userData.once('value').then(snapshot => {
        if (snapshot.val()) {
            callback(snapshot.val());
        }
        else {
            errorHandler();
        }
    });
};

export const removeFireBaseData = (database, table, params) => {
    const userData = database.database().ref(table + params);
    userData.remove();
};


export const subscribeToFirebase = (firebase, params, dispatch, reducer) => {
    const locationData = firebase.database().ref('locations/' + params);

    locationData.on('value', snapshot => {
        if (snapshot.val()) {
            const payload = {
                id: params,
                firebaseResponse: snapshot.val(),
            };
            dispatch(reducer(payload));
        }
    }, error => {
        if (process.env.REACT_APP_ENV === 'stage') {
            let checkInit = setInterval(
                () => {
                    if (window.sessionStorage.getItem('firebaseSignIn') === 'true') {
                        subscribeToFirebase(firebase, params, dispatch, reducer);
                        clearInterval(checkInit);
                    }
                },
                800
            );
        }
        console.log(error);
    });
};

export const unSubscribeFromFirebase = (database, params) => {

    const locationData = database.database().ref('locations/' + params);

    locationData.off();
};

export const checkLocation = (start, duration) => {
    const currentTime = Math.floor(new Date().getTime());

    const durationInMilSec = duration * 1000;

    const endTime = start + durationInMilSec;

    if (currentTime <= endTime) {
        return true;
    } else {
        return false;
    }

};

export const isTimestampExpired = (timestamp, validityPeriod) => {
    const currentTime = Math.floor(new Date().getTime());
    const diff = currentTime - (timestamp * 1000);
    let isExp = diff > validityPeriod ? true : false;

    return isExp;
};

export const getCurrentPosition = (dispatch, action) => navigator.geolocation.getCurrentPosition((position) => {
    dispatch(action({
        browserLat: position.coords.latitude,
        browserLng: position.coords.longitude
    }));
});

const calculateTime = (duration, sharingStartTime) => {
    const currentTime = new Date().getTime();
    const timePast = currentTime - sharingStartTime;
    const diff = duration * 1000 - timePast;

    const countDownDate = currentTime + diff;

    const distance = countDownDate - currentTime;

    const hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
    const mins = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));

    return {
        distance,
        hours,
        mins
    };
};

export const calculateOffset = (lat, lng) => {
    const r_earth = 6371000.0;
    const dy = 3000;
    const dx = 3000;

    const newLat = lat  + (dy / r_earth) * (180 / Math.PI);
    const newLng = lng  + (dx / r_earth) * (180 / Math.PI);

    return {
        newLat,
        newLng
    };
};


export const startTimer = (sharingStartTime, duration, dispatch, setTimerData, setSharingStatus) => {

    const {hours, mins} = calculateTime(duration, sharingStartTime);

    dispatch(setTimerData({hours: hours, mins: mins}));


    const timer = setInterval(() => {

        const {distance, hours, mins} = calculateTime(duration, sharingStartTime);

        if (distance < 0) {
            clearInterval(timer);
            dispatch(setSharingStatus(false));
            dispatch(setTimerData({
                hours: 0,
                mins: 0
            }));
            return;
        }

        dispatch(setTimerData({
            hours: hours,
            mins: mins,
        }));

    }, 60000);

    return timer;
};


export const convertTime = (moment, timestamp) => {
    return moment(timestamp * 1000).format('h:mm a');
};

export const convertTimeFromNow = (moment, timestamp = 0) => {
    return moment(timestamp * 1000).fromNow();
};


export const usePrevious = data => {
    const ref = useRef();
    useEffect(() => {
        ref.current = data;
    }, [data]);

    return ref.current;
};


export default function useDebounce(value, delay) {
    const [debouncedValue, setDebouncedValue] = useState(value);

    useEffect(
        () => {
            const handler = setTimeout(() => {
                setDebouncedValue(value);
            }, delay);
            return () => {
                clearTimeout(handler);
            };
        },
        [value, delay]
    );

    return debouncedValue;
}

export const formatID = str => str.toString().match(/.{1,3}/g).join(' ');


//Map Utils

export const initializeMap = (lat, lng, createMap) => {
    const currentLocation = {lat: parseFloat(lat), lng: parseFloat(lng)};

    const initMap = () => {
        const geocoder = new window.google.maps.Geocoder();

        geocoder.geocode({location: {lat, lng}}, (results, status) => {
            if (status === 'OK') {
                if (results[0]) {
                    createMap(currentLocation);
                }
            }
        });
    };

    const googleMapScript = document.createElement('script');
    googleMapScript.src = `https://maps.googleapis.com/maps/api/js?key=${process.env.REACT_APP_GOOGLE_MAPS_API}&libraries=&v=beta`;
    googleMapScript.async = true;

    window.document.body.appendChild(googleMapScript);

    googleMapScript.addEventListener('load', () => {
        initMap();
    });
};

export const formatLatLng = (lat, lng) => new window.google.maps.LatLng(lat, lng);

export const calculateDistance = (lat1, lon1, lat2, lon2) => {
    const p = 0.017453292519943295;    // Math.PI / 180
    const c = Math.cos;
    const a = 0.5 - c((lat2 - lat1) * p)/2 +
        c(lat1 * p) * c(lat2 * p) *
        (1 - c((lon2 - lon1) * p))/2;

    const km = 12742 * Math.asin(Math.sqrt(a));

    return km * 1000;
};

//Canvas func

export const drawCanvas = (img, deviceIcon = '', isActive, status, callback) => {

    const MARKER_BG_GREEN = '../images/bg-green-big.png';
    const MARKER_BG_WHITE = '../images/bg-white-big.png';
    const STATUS_URL = `../images/${status}.png`;

    const canvas = document.createElement('canvas');
    canvas.width = 140 * devicePixelRatio;
    canvas.height = 140 * devicePixelRatio;

    const ctx = canvas.getContext('2d');
    ctx.scale(devicePixelRatio, devicePixelRatio);
    canvas.style.width = '140px';
    canvas.style.height = '140px';

    const radius = 38;

    ctx.clearRect(0, 0, canvas.width, canvas.height);

    const deviceLabel = new Image(16, 16);
    const background = new Image(88, 105);
    const statusIco = new Image(16, 16);
    const avatar = new Image();

    avatar.src = img;
    statusIco.src = STATUS_URL;
    deviceLabel.src = deviceIcon;
    background.src = isActive ? MARKER_BG_GREEN : MARKER_BG_WHITE;
    avatar.crossOrigin = 'anonymous';
    background.crossOrigin = 'anonymous';
    statusIco.crossOrigin = 'anonymous';
    deviceLabel.crossOrigin = 'anonymous';

    const drawIcon = (imageWidth, imageHeight) => {
        ctx.drawImage(background, 15, 15, 108, 116);
        ctx.drawImage(statusIco,  80, 90, 32, 32);
        if (deviceIcon) {
            ctx.drawImage(deviceLabel,  90, 19, 20, 20);
        }

        ctx.arc(69, 67, radius, 0, 2 * Math.PI, true);
        ctx.clip();


        if (imageWidth !== imageHeight) {
            ctx.drawImage(avatar, 22, 20, 90, 110);
        }

        else {
            ctx.drawImage(avatar, 24, 20, 90, 90);
        }

        setTimeout(() => callback(canvas.toDataURL('image/png', 2)), 300);
    };

    avatar.onload = () => {
        const imageWidth = avatar.naturalWidth;
        const imageHeight = avatar.naturalHeight;


        setTimeout(() => drawIcon(imageWidth, imageHeight), 100);
    };
};


export const moveMapEl = (lat, lng, prevLat = lat, prevLng = lng, moveCb) => {

    const result = [lat, lng];
    const position = [prevLat, prevLng];

    const NUM_DELTAS = 100;
    const DELAY = 10; //milliseconds
    let i = 0;
    let deltaLat;
    let deltaLng;


    const moveEl = () => {


        position[0] += deltaLat;
        position[1] += deltaLng;

        const latlng = new window.google.maps.LatLng(position[0], position[1]);

        moveCb(latlng);

        if (i !== NUM_DELTAS) {
            i++;
            setTimeout(moveEl, DELAY);
        }
    };

    if (lat && prevLat && lng && prevLng) {
        deltaLat = (result[0] - position[0]) / NUM_DELTAS;
        deltaLng = (result[1] - position[1]) / NUM_DELTAS;

        if (deltaLat !== 0 && deltaLng !== 0) {
            moveEl();
        }
    }
};


//Detecting that user has been idle

export function detectIfIdle(func, delay) {
    let t;
    window.onload = resetTimer;
    window.onmousemove = resetTimer;
    window.onmousedown = resetTimer;
    window.ontouchstart = resetTimer;
    window.onclick = resetTimer;
    window.onkeydown = resetTimer;
    window.addEventListener('scroll', resetTimer, true);


    function resetTimer() {
        clearTimeout(t);
        t = setTimeout(func, delay);  // time is in milliseconds
    }
}

export const getCookie = name => {
    // eslint-disable-next-line
    const regex = new RegExp('(?:^|; )' + name.replace(/([$?*|{}\[\]\\\/^])/g, '\\$1') + '=([^;]*)');
    let matches = document.cookie.match(regex);
    return matches ? decodeURIComponent(matches[1]) : undefined;
};

export const calcPercent = (partialValue, totalValue) => (100 * partialValue) / totalValue;








